import { createContext, useContext } from "react";

const context = createContext<"light" | "dark">("light");

export const ColorScheme = context.Provider;

export const useColorScheme = () => useContext(context);
